<div class="w-full h-full flex flex-col">
    <div id="header" class="sticky top-0 z-50 bg-white py-3 border-b-[1px] border-b-[#d5e5f6] lg:shadow-none shadow-sm">
        <app-header [isAuthLayout]="!isUserLoggedIn"></app-header>
        @if (isClientSide() && isUserLoggedIn) {
            <app-desktop-navbar></app-desktop-navbar>
        }
    </div>
    
    <div class="w-full flex-1 flex items-center justify-center">
        <div class="py-[10vh] !px-[20px] sm:!px-0 flex flex-col justify-center text-center items-center">
            <img src="/assets/images/error-404-icon.svg" alt="error-404-icon" 
                class="object-contain w-[80%] sm:w-full max-w-[370px] max-h-[267px]"
            >
            <p class="w-full text-[#231F20] font-semibold text-lg sm:text-2xl mt-2">
                {{ 'invalidUrl.invalidUrlTitle' | translate }}
            </p>

            <p class="w-full text-[#4B4848] font-lato font-normal text-sm sm:text-base mt-2">
                {{ 'invalidUrl.invalidUrlDescriptionLine1' | translate }}
            </p>
            <p class="w-full text-[#4B4848] font-lato font-normal text-sm sm:text-base">
                {{ 'invalidUrl.invalidUrlDescriptionLine2' | translate }}
            </p>

            <button 
                type="button" 
                class="btn-primary !py-3 !px-5 m-auto mt-[1.875rem]" 
                [routerLink]="isUserLoggedIn ? ['/home'] : ['/login']"
            >
                {{ (isUserLoggedIn ? 'button.backToHomepage' : 'button.backToLoginPage') | translate }}
            </button>
        </div>
    </div>
</div>
